export default "__VITE_ASSET__CG6XXZCK__"